export default __webpack_public_path__ + "static/media/logo-meta-mask.ed422216.svg";